import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Relaxation11 = () => {
  return (
    <div>
      <section className="flex mt-[30px] gap-6 px-5 mb-[40px] text-[#2A5801]">
        {/* relaxation */}
        <div
          id="relaxation"
          className="bg-white w-full px-4 shadow-lg rounded-[10px]"
        >
          <div className="inline-block mx-[10px] px-[5px] rounded-[5px] mt-[10px]">
            <h2 className="text-xl font-bold">RELAXATION</h2>
          </div>
          <div>
            <h4 className="mx-[18px] mt-[5px] text-[#2A5801] font-semibold">
              PLEASE CHOOSE ONE
            </h4>
          </div>
          <div className="pt-20 space-y-8">
            <div>
              <Link to="https://www.youtube.com/watch?v=GWwuprkqV5I" />
              <button className=" w-full  px-4 py-3 border-2 border-[#295700] text-center text-[#295700] rounded-sm">
                Relaxing Soundscapes
              </button>
            </div>
            <div>
              <Link to="https://www.youtube.com/watch?v=F28MGLlpP90" />
              <button className=" w-full  px-4 py-3 border-2 border-[#295700] text-[#295700] text-center text-[#295700 rounded-sm">
                Relax And Breath
              </button>
            </div>
            <div>
              <Link to="https://www.youtube.com/watch?v=ynLpZGegiJE" />
              <button className=" w-full   px-4 py-3 border-2 border-[#295700] text-[#295700] text-center text-[#295700 rounded-sm">
                A Walk In The Wood
              </button>
            </div>
            <div>
              <Link to="https://www.youtube.com/watch?v=tI16SNCtMrQ" />
              <button className=" w-full  px-4 py-3 border-2 border-[#295700] text-[#295700] text-center text-[#295700 rounded-sm">
                Increase Productivity
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Relaxation11;
